var _filter, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1771,
    height: 2500,
    viewBox: "221.807 89.47 440 621.061",
    enableBackground: "new 221.807 89.47 440 621.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "150%",
    height: "150%",
    x: "-5%",
    y: "-5%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    result: "floodFill",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "floodFill",
    in2: "SourceAlpha",
    operator: "in",
    result: "coloredAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "coloredAlpha",
    result: "blur",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "blur",
    in2: "SourceGraphic",
    operator: "out",
    result: "maskedOffsetBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "maskedOffsetBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e44d26",
    d: "M261.849 660.647l-40.042-449.125h440l-40.086 449.054-180.184 49.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f16529",
    d: "M441.807 672.348l145.596-40.367 34.258-383.735H441.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M441.807 414.82h-72.888l-5.035-56.406h77.923V303.33H303.683l1.32 14.778 13.538 151.794h123.266zM441.807 557.876l-.242.066-61.346-16.566-3.922-43.93h-55.294l7.718 86.489 112.834 31.323.252-.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.745 89.47h27.992v27.656h25.606V89.47h27.993v83.75h-27.993v-28.044h-25.606v28.044h-27.99l-.002-83.75zM381.149 117.244h-24.642V89.47H433.8v27.774h-24.654v55.976H381.15v-55.976h-.001zM446.065 89.47h29.19l17.955 29.428 17.938-29.428h29.2v83.75h-27.882v-41.512l-19.259 29.778h-.481l-19.272-29.778v41.512h-27.39V89.47zM554.277 89.47h28v56.068h39.368v27.682h-67.368V89.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M441.617 414.82v55.082h67.83l-6.395 71.44-61.435 16.58v57.307l112.924-31.294.826-9.309 12.946-145.014 1.344-14.792h-14.842zM441.617 303.33v55.084H574.67l1.103-12.382 2.51-27.924 1.318-14.778z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.3efc40a5a74d582b365829a89d5f443f.svg";
export { ForwardRef as ReactComponent };